import AdvertisingImportCreatePage from './AdvertisingImportCreatePage';

export default AdvertisingImportCreatePage;
